export default "__VITE_ASSET__0462791f__"